import React from "react";
import classNames from "../classNames";

const defaultProps = {
    className: "btn btn-primary"
}

function Button({className, loading, progress, children, disabled, ...props}) {
    loading = loading || progress;
    const defaultStyle = {
        cursor: loading ? "wait" : ""
    };
    const attributes = {
        className: className,
        style: {
            ...defaultStyle,
        },
        ...props
    };
    return (
        <button
            {...attributes}
            disabled={loading || disabled}>
            {loading &&
                <div className={classNames("spinner-border text-secondary spinner-border-sm", children && "me-2")}/>}
            {children}
        </button>
    )
}

Button.defaultProps = defaultProps;
export default Button;
